import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { formatDecimals, formatLocal } from 'utils'
import { CNR } from 'constants/tokens'
import { TruncateTxn } from 'components/Utils'

const BurnTableColumns = [
  {
    title: 'Txn Hash',
    dataIndex: 'txid',
    render: (txid) => (
      <Link to={`/transaction/${txid}`}>
        <TruncateTxn address>{txid}</TruncateTxn>
      </Link>
    ),
    width: 180,
  },
  {
    title: 'Age',
    dataIndex: 'date',
    render: (timestamp) => moment(timestamp).fromNow(),
    width: 140,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (confirmed) => (confirmed ? <span>CONFIRMED</span> : <span>UNCONFIRMED</span>),
  },
  {
    title: 'Price Block',
    dataIndex: 'priceBlock',
  },
  {
    title: 'Burn Amount',
    dataIndex: 'burnAmount',
    render: (burnAmount) => {
      return (
        <span>
          {formatLocal(formatDecimals(burnAmount, 8), 2)}&nbsp;
          <Link to={`/tokens/${CNR.shortName.toLowerCase()}`}>{CNR.symbol}</Link>
        </span>
      )
    },
  },
]

export default BurnTableColumns
